import React, { useRef, useContext, useEffect } from "react";
import "./styles.scss";
import { Icon } from "semantic-ui-react";

const DialogContext = React.createContext();

export function useDialog() {
  return useContext(DialogContext);
}

export default function DialogModal({
  children,
  isOpen,
  setOpen,
  style,
  disallowClickoff,
  disallowAutoFocus,
  isButtonClose,
}) {
  const modalRef = useRef(null);

  const handleClickOutside = (e) => {
    if (disallowClickoff === true) return;
    const dialogDimensions = modalRef.current.getBoundingClientRect();
    if (
      e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
    ) {
      setOpen(false);
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    setOpen(false)
  }

  const value = {
    ref: modalRef,
  };

  useEffect(() => {
    if (modalRef.current) {
      if (disallowAutoFocus) modalRef.current.inert = true;

      isOpen ? modalRef.current.showModal() : modalRef.current.close();
      if (disallowAutoFocus) modalRef.current.inert = false;
    }
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const dialog = modalRef.current;
    if (!dialog) return;

    const handleDialogClose = () => {
      setOpen(false);
    };

    dialog.addEventListener("close", handleDialogClose);

    return () => {
      dialog.removeEventListener("close", handleDialogClose);
    };
  }, []);

  return (
    <DialogContext.Provider value={value}>
      <dialog
        ref={modalRef}
        className="dialog-modal"
        onClick={(e) => handleClickOutside(e)}
        style={{
          minWidth: 350,
          border: "1px solid var(--elevation-6)",
          ...style,
        }}
      >
        {isButtonClose && (
          <button className="dialog-modal__close" onClick={handleClose} aria-label="Close Modal">
            <Icon name="close" />
          </button>
        )}

        {children}
      </dialog>
    </DialogContext.Provider>
  );
}
